/* Caleculate age by the birthday
 *  @params birthday(String)
 *  @return Object
 */
export function CaleculateAge(birthday) {
  const calculatedAge = new Date(Date.parse(Date()) - Date.parse(birthday));
  const year = calculatedAge.getFullYear() - 1970;
  const month = calculatedAge.getMonth();
  const day = calculatedAge.getDate() - 1;
  return {
    year,
    month,
    day,
  };
}
